import { type ReactNode } from 'react';

import { useCardClickAction } from '@/microfrontends/listing/shared/hooks/useCardClickAction';

import { useActivePinIdSelector } from '@/packages/redux-state/store/slices/mapControls';
import { useMapSelectedBoundsSelector } from '@/packages/redux-state/store/slices/mapControls/selectors/dumb';

import { useCardOfferContext } from '../../../../context/selectors';
import { LayoutWide } from '../../components/desktop/Layout';
import { CardGalleryContainer } from '../../containers/desktop/CardGallery';
import { CardThumbnailsContainer } from '../../containers/desktop/CardThumbnails';
import { ControlsContainer } from '../../containers/desktop/ControlsContainer';
import { PublisherCard } from '../../containers/desktop/PublisherCard';
import { VASBlockContainer } from '../../containers/desktop/VASBlockContainer';

import { CardContentContainer } from './internal/containers/CardContentContainer';

export function FlatRentCardWide(): ReactNode {
  const {
    data: {
      extendedProperties: { offerServices },
      areaParts,
    },

    id: offerId,
  } = useCardOfferContext();

  const activePinId = useActivePinIdSelector();
  const selectedBounds = useMapSelectedBoundsSelector();

  const handleCardClick = useCardClickAction(true, !!activePinId, !!selectedBounds);

  return (
    <LayoutWide
      content={<CardContentContainer />}
      controls={<ControlsContainer />}
      gallery={<CardGalleryContainer />}
      isMulti={!!areaParts}
      isTop3={!!offerServices?.isTop3}
      publisher={<PublisherCard />}
      testId={`card.${offerId}`}
      thumbnails={<CardThumbnailsContainer />}
      vas={<VASBlockContainer />}
      onClick={handleCardClick}
    />
  );
}
